import { dataThumbUpSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconThumbUpSolid = /*#__PURE__*/createIcon(dataThumbUpSolid)
export default IconThumbUpSolid
